import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import ButtonWrapper from "../../../components/Button";
import { Col, Container, Row } from "react-bootstrap";
import { filterCategory } from "../helpers/helpers";
import InputWrapper from "../../../layout/inputWrapper";

const SubStep3 = ({ formData, handleSubTabChange, t, archData, validity, usersData, isEmployee, isApproved }) => {
  // const consultantCategory = filterCategory(archData?.roles);
  console.log("validityFromSUb3", formData, archData, validity, usersData);

  const defaultValues = {
    ...formData,
    professionalInformation: {
      ...formData?.professionalInformation,
      // consultantCategory: consultantCategory,
      planDate: formData?.professionalInformation?.planDate || validity,
      licenseNumber: formData?.professionalInformation?.licenseNumber || usersData?.[0]?.registrationNumber,
      certificateNumber: formData?.professionalInformation?.certificateNumber || usersData?.[0]?.registrationArchitectNumber,
    },
  };
  const { handleSubmit, control } = useForm({ defaultValues });
  const onSubmit = (data) => {
    data = {
      ...data,
      professionalInformation: {
        ...data.professionalInformation,

        consultantCategory: formData?.professionalInformation?.consultantCategory,
        licenseNumber: usersData?.[0]?.registrationNumber,
        planDate: validity,
        certificateNumber: usersData?.[0]?.registrationArchitectNumber,
      },
    };
    console.log("dataFromSUb3", data);
    handleSubTabChange(2, data);
  };
  return (
    <section className="groupContainer3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Licensed Technical Professional (LTP) Information")}</h2>
          </div>
          <Container className="formInputContainer common-app-form px-4" fluid>
            <Row>
              {/* Column 1 */}
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Consultant Category"
                  control={control}
                  disabled={Boolean(formData?.professionalInformation?.consultantCategory) || isEmployee || isApproved}
                  placeholder="Enter Consultant Category"
                  name="professionalInformation.consultantCategory"
                  type="textInput"
                  defaultValue={formData?.professionalInformation?.consultantCategory}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  maxLength={30}
                  className={Boolean(formData?.professionalInformation?.consultantCategory) ? "input-disabled" : ""}
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Name"
                  control={control}
                  disabled={Boolean(formData?.professionalInformation?.name) || isEmployee || isApproved}
                  placeholder="Enter Name"
                  // defaultValue={archData?.name}
                  name="professionalInformation.name"
                  validation={{
                    pattern: {
                      value: Digit.Utils.getPattern("Name"),
                      message: "Please enter only letters and spaces",
                    },
                  }}
                  isRequired={true}
                  type="textInput"
                  mandatory
                  maxLength={30}
                />
              </Col>
            </Row>

            <Row>
              {/* Column 2 */}
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Validity"
                  control={control}
                  placeholder="Validity"
                  name="professionalInformation.planDate"
                  type="textInput"
                  defaultValue={validity}
                  disabled={Boolean(validity) || isEmployee || isApproved}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Mobile No."
                  control={control}
                  placeholder="Enter Mobile No."
                  disabled={Boolean(formData?.professionalInformation?.mobileNumber) || isEmployee || isApproved}
                  // defaultValue={archData?.mobileNumber}
                  name="professionalInformation.mobileNumber"
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  maxLength={10}
                />
              </Col>
            </Row>

            <Row>
              {/* Column 3 */}
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  disabled={isEmployee || isApproved}
                  label="Certificate No. (For Minimum Qualification)"
                  name="professionalInformation.certificateNumber"
                  defaultValue={usersData?.[0]?.registrationArchitectNumber}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  height="30px"
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  disabled={Boolean(usersData?.[0]?.registrationNumber) || isEmployee || isApproved}
                  label="License No."
                  name="professionalInformation.licenseNumber"
                  defaultValue={usersData?.[0]?.registrationNumber}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                />
              </Col>
            </Row>

            <Row>
              {/* Column 4 */}
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="E-mail Id"
                  control={control}
                  disabled={Boolean(formData?.professionalInformation?.emailId) || isEmployee || isApproved}
                  placeholder="Enter E-mail Id"
                  defaultValue={formData?.professionalInformation?.emailId}
                  name="professionalInformation.emailId"
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>
          <div className="footerContainer2">
            {!isEmployee && !isApproved && (
              <div className="buttonWrapper">
                <ButtonWrapper
                  variant="contained"
                  color="error"
                  size="medium"
                  label="Prev"
                  sx={{ backgroundColor: "#CCC", marginRight: "4px" }}
                  onClick={() => handleSubTabChange(1)}
                />
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label="Save"
                  type="submit"
                  sx={{ backgroundColor: "#000", marginRight: "4px" }}
                />
              </div>
            )}
          </div>
        </div>
      </form>
    </section>
  );
};

export default SubStep3;
